<template>
    <modal v-if="bindPropModal" @close="closeModal" v-cloak :class-dialog="'modal-dialog modal-lg'">
        <h4 slot="header" class="modal-title">
            Endereço de entrega
        </h4>
        <div class="row pr-3 pl-3" slot="body">
            <grouped-errors ref="groupedErrors"></grouped-errors>
            <form-address v-model="address" :ref="`address_${_uid}`" :has-people-contact="hasPeopleContact"></form-address>
        </div>

        <div slot="footer">
            <button type="button" class="btn btn-light" @click="closeModal">Cancelar</button>
            <button type="button" class="btn btn-success" @click="save">Gravar</button>
        </div>
    </modal>
</template>

<script>
    import FormAddress from "./FormAddress";
    export default {
        name: "ModalAddress",
        components: {FormAddress},
        data(){
            const _this = this;
            return {
                address: {
                    people_contact: '',
                    phone: '',
                    ...this.value
                },
                bindPropModal: _this.showModal,
            }
        },

        props: {
            value: {
                default: null,
            },
            hasPeopleContact: {
                default: true,
            },
            showModal: {
                default: false,
            },
            action: {
                type: String,
                default: 'store',
            }
        },

        watch: {
            address: {
                deep: true,
                handler(value) {
                    this.$emit('input', value);
                }
            },
            showModal(newValue) {
                this.bindPropModal = newValue;
            },
            bindPropModal(newValue){
                if (newValue) {
                    this.$emit('open', newValue);
                } else {
                    this.$emit('close', newValue);
                }
            }
        },

        created(){},

        mounted() {},

        methods: {
            async save(){
                const form = this.$refs[`address_${this._uid}`].form;

                if (this.action === 'store') {
                    try {
                        const { data } = await this.$axios.post(route('api.auth.createAddress'), form);
                        this.$emit('created', data)
                    } catch (e) {
                        console.error(e)
                        let errors = this.$refs.groupedErrors.set(e);
                        this.$emit('error', errors)
                        return false;
                    }
                }

                if (this.action === 'update') {
                    try {
                        const { data } = await this.$axios.put(route('api.address.update', form.id), form)

                        this.$emit('updated', data)
                    } catch (e) {
                        let errors = this.$refs.groupedErrors.set(e);
                        this.$emit('error', errors)
                        return false;
                    }
                }

                this.closeModal()
            },
            closeModal(){
                this.bindPropModal = !this.bindPropModal;
            },
        }
    }
</script>

<style scoped>

</style>
